<template>
    <div class="input-container">
        <input :type="getType()" :class="{'red': msgtext !== '' || (msgtext === 'Ошибка авторизации' && params.name === 'password')}" @click="getAction" v-on:keyup.enter="getOnEnter" v-model="value" :value="getText()" :placeholder="getPHolder()">
        
        <div class="svg" v-if="params.name == 'login'">
             <svg  class="svg_gmail" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="#3D3D3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
        </div>
        <div class="svg" v-if="params.name == 'password'">
             <svg  class="svg_lock" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z" stroke="#3D3D3D" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
        </div>
             
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: "afinputBox",
  props: {
    msgtext: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
      showpas: {
        type: Boolean,
        required: true
    }
  },
  data(){
    return {
      value: this.params.type!='button'?"":this.params.text
    }
  },
  watch:{
    value:{
      handler(n){
        if(this.params.type != 'button') this.params.text = n;
      }
    }
  },
  methods:{
    getType(){
        if(this.showpas && this.params.type == 'password') {
            return 'text'
        }
      if(this.params.type != undefined ){
        return this.params.type;
      }
    },
    getText(){
      if(this.params.text != undefined){
        return this.params.text;
      }
      return ''
    },
    getAction(){
      if(this.params.action) {
        return this.params.action(this.params);
      }
    },
    getOnEnter(){
      if(this.params.onenter) {
        return this.params.onenter(this.params);
      }
    },
    getPHolder(){
      if(this.params.placeholder) {
        return this.params.placeholder;
      }
      return "";
    }
  }
}
</script>

<style scoped>
.input-container {
  width: 100%;
  position: relative;

}
  input {
    border: 1px solid #3D3D3D;
    border-radius: 10px;
    outline: none;
    background: none;
    width: 100%;
    box-sizing: border-box;
    height: 48px;
    margin-top: 20px;
    background-color: #FFFFFF0D;
    text-align: left;
    padding-left: 60px;
    font-size: 15px;
    color: #FFF;
    transition: all .3s;
  }
  input:hover {
    cursor: pointer;
    border: 1px solid #FFBC0D80;
    box-shadow: 0px 2px 6px 0px #FFB4004D;

  }
  
.svg {
    position: absolute;
    top: 32px;
    display: flex;
    align-items: center;
    left: 10px;
    border-right:1px solid #3D3D3D;
    padding-right: 10px;
}
  input[type=button]{
    border: none;
    background: #FFBC0D;
    box-shadow: 0px 2px 6px 0px #FFB4004D;
    width: 100%;
    height: 40px;
    padding: 10px;
    color: #fff;
    text-align: center;
    font-size: 15px;
    font-weight: 700;
  }
  input:focus {
    border: 1px solid var(--Brand-yellow, #FFBC0D);
    box-shadow: 0px 0px 10px 0px #FFBC0D14;

  }
  input svg .svg path{
    transition: all .3s;
  }
  input:focus + .svg svg path{
    stroke: #FFBC0D;
  }
  .red {
    border: 1px solid #EF5350;
  }
  .red + .svg svg path{
    stroke: #EF5350;
  }
</style>